import { Component, ViewChild } from '@angular/core';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { CPSearchComponent } from '@app/cp/shared/search/cp-search/cp-search.component';
import { DQOIItem } from '../shared/models/DQOIItem';
import { DQOIService } from '../shared/services/DQOI.service';
import { OrdersComponent } from '../orders/orders.component';
import { SearchTarget } from '../shared/enums/SearchTarget';
import { DQOISearchEvent } from '../shared/models/DQOISearchEvent';
import { UseCPLoader, ICPLoader } from '../shared/decorators/cploader/cploader-decorator';

@UseCPLoader()
@Component({
    selector: 'order-search',
    templateUrl: './order-search.component.html',
    styleUrls: ['./order-search.component.scss'],
    standalone: false
})
export class OrderSearchComponent  {
    compLoader: ICPLoader = this as any;
    @ViewChild('cpSearch') cpSearch: CPSearchComponent;
    @ViewChild('mainComp') mainComp: OrdersComponent;

    svc_data: DQOIService;

    public orderNumber: string;

    constructor(
        svc_data: DQOIService,) {
        this.svc_data = svc_data;
    }

    dqoiItem: DQOIItem;
    searchCode: string = 'Orders';
    searchText: string = 'Search Orders';
    isConstruction: boolean = false;
    clear() {
        this.orderNumber = '';
        this.mainComp.clear();
    }
    cpSearchActive: boolean = false;
    cpSelected(value: any) {
        this.cpSearchActive = false;
        if (value) {

            this.clear();
            this.orderNumber = value.OrderNumber;
            if (CommonFunctions.hasGuidValue(value.OrderId)) {
                let idTarget = SearchTarget.order + ":" + value.OrderId;
                this.svc_data.getDQOITemFromDb(idTarget).subscribe((newData: DQOIItem) => {
                    let item: DQOIItem = new DQOIItem(newData);
                    item.index = 1;
                    this.isConstruction = item.isConstruction;

                    this.svc_data.setDQOIItem(item);
                    let se: DQOISearchEvent = new DQOISearchEvent();
                    se.isNew = false;
                    se.searchTarget = SearchTarget.order;
                    se.orderNumber = item.orderNumber;
                    se.dqoiItem = item;
                    this.svc_data.nextSearchEvent(se);

                });
            }
        }
    }

    doSearch(e: any) {
        if (CommonFunctions.hasStringValue(e) && e === "CLEAR") {
            this.cpSelected({ OrderNumber: "", OrderId: null });
        }
        else {
            this.cpSearchActive = true;
            this.cpSearch.setSearchText(e);
        }
    }

}
